<template>
  <div>
  <div class="card-header d-flex justify-content-between">
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <span class="nav-link active" v-if="medicineType === 'hvlp'" :data-testid="testIdPrefix + '-medicament-type-hvlp'">HVLP</span>
        <button @click="switchMedicineType('hvlp')" class="nav-link" v-else :data-testid="testIdPrefix + '-medicament-type-hvlp'">HVLP</button>
      </li>
      <li class="nav-item">
        <span class="nav-link active" v-if="medicineType === 'iplp'" :data-testid="testIdPrefix + '-medicament-type-iplp'">IPLP</span>
        <button @click="switchMedicineType('iplp')" class="nav-link" v-else :data-testid="testIdPrefix + '-medicament-type-iplp'">IPLP</button>
      </li>
    </ul>
  </div>
  <div class="card-body bg-info">
    <div class="card-text">
      <form @submit.prevent="saveMedicament">
        <div class="form-row align-items-end">
          <div class="col-sm-11 mb-2" v-if="medicineType === 'hvlp'">
            <label for="searchMedicine">Lék</label>
            <multiselect v-model="selected" id="searchMedicine" label="label" track-by="code" open-direction="bottom" placeholder="vyhledat lék"
                         :options="medicines" :multiple="false" :searchable="true" :internal-search="false"
                         :close-on-select="true" :options-limit="300" :limit="3" :max-height="400"
                         :show-no-results="false" :hide-selected="false" @search-change="getResult"
                         @select="selectMedicine" selectLabel="vybrat" :data-testid="testIdPrefix + '-medicament-search'">
              <template slot="option" scope="props">
                <div class="option__desc">
                            <span class="option__title"
                                  :class="props.option.available === true ? 'available' : 'unavailable'">
                              <div class="row m-0 pb-0 font-sm">
                                <div class="col-sm-6">
                                  <i class="fas fa-coins" style="color: goldenrod;"
                                     v-if="props.option.has_actual_insruance_cover === true"></i>
                                  {{ props.option.label }}
                                </div>
                              </div>
<!--                              <div class="row m-0 font-xs">-->
<!--                                <div class="col-sm-6">-->
<!--                                  <span>{{-->
<!--                                      props.option.indication_group ? props.option.indication_group.name_cs : '&nbsp;'-->
<!--                                    }}</span>-->
<!--                                  <i class="fa fa-trophy text-danger" v-if="props.option.doping"-->
<!--                                     :title="props.option.doping.name_cs"></i>-->
<!--                                  <i class="fa fa-gavel text-danger" v-if="props.option.government_regulation"-->
<!--                                     :title="props.option.government_regulation.name_cs"></i>-->
<!--                                  <i class="fa fa-joint text-danger" v-if="props.option.addiction"-->
<!--                                     :title="props.option.addiction.name_cs"></i>-->
<!--                                </div>-->
<!--                              </div>-->
                            </span>
                </div>
              </template>
            </multiselect>
            <small id="medicineError" class="form-text font-weight-bold"
                   v-if="medicamentError.medicine">{{ medicamentError.medicine.message }}</small>
          </div>
          <div class="col-sm-11 mb-2" v-if="medicineType === 'iplp'">
            <label for="searchMedicine">Individuální léčivý přípravek</label>
            <multiselect v-model="selected" id="searchMedicine" label="name" track-by="id" placeholder="vyhledat lék"
                         :options="individualMedicines" :multiple="false" :searchable="true" :internal-search="false"
                         :close-on-select="true" :options-limit="300" :limit="3" :max-height="600"
                         :show-no-results="false" :hide-selected="false" @search-change="getIndividualMedicines"
                         @select="selectIndividualMedicine" selectLabel="vybrat">
              <template slot="option" scope="props">
                <div class="option__desc">
                            <span class="option__title available">
                              <div class="row m-0 pb-1">
                                <div class="col-sm-6">
                                  {{ props.option.name }}
                                </div>
                              </div>
<!--                              <div class="row m-0 font-sm">-->
<!--                                <div class="col-sm-6">-->
<!--                                  <span>{{-->
<!--                                      props.option.indication_group ? props.option.indication_group.name_cs : '&nbsp;'-->
<!--                                    }}</span>-->
<!--                                  <i class="fa fa-trophy text-danger" v-if="props.option.doping"-->
<!--                                     :title="props.option.doping.name_cs"></i>-->
<!--                                  <i class="fa fa-gavel text-danger" v-if="props.option.government_regulation"-->
<!--                                     :title="props.option.government_regulation.name_cs"></i>-->
<!--                                  <i class="fa fa-joint text-danger" v-if="props.option.addiction"-->
<!--                                     :title="props.option.addiction.name_cs"></i>-->
<!--                                </div>-->
<!--                              </div>-->
                            </span>
                </div>
              </template>
            </multiselect>
            <small id="medicineError" class="form-text font-weight-bold"
                   v-if="medicamentError.medicine">{{ medicamentError.medicine.message }}</small>
          </div>
          <div class="col-sm-1 mb-2">
            <i class="fa fa-spinner fa-pulse fa-2x fa-fw" v-if="clientMedicineInfoPending === true"></i>
          </div>
        </div>

        <div class="form-row" v-if="medicineType === 'iplp' && selected">
          <span style="white-space: pre;" v-html="selected.preparation_process"/>
        </div>

        <div class="form-row align-items-end">
          <div class="col-sm-6 mb-2">
            <label for="searchDiagnosis">Diagnóza</label>
            <multiselect v-model="selectedDisease" id="searchDiagnosis" label="label" track-by="code"
                         placeholder="vyhledat diagnózu" :options="diseases" :multiple="false" :searchable="true"
                         :internal-search="false" :close-on-select="true" :options-limit="300" :limit="3"
                         :max-height="600" :show-no-results="false" :hide-selected="true" @search-change="getDiseases"
                         @select="selectDisease" selectLabel=""></multiselect>
          </div>
          <div class="col-sm-6 mb-2">
            <label for="paidBySick">Hradí pacient</label>
            <div>
              <label class="switch switch-lg switch-text switch-success">
                <input v-model="medicament.paid_by_sick" type="checkbox" class="switch-input" id="paidBySick" checked :data-testid="testIdPrefix + '-medicament-paid-by-client'">
                <span class="switch-label" data-on="Ano" data-off="Ne"></span>
                <span class="switch-handle"></span>
              </label>
            </div>
          </div>
        </div>
        <div class="form-row align-items-begin">
          <div class="col-sm-4 mb-2">
            <label for="amount">Počet balení</label>
            <input v-model="medicament.amount" type="number" class="form-control" aria-describedby="operationHelp"
                   id="amount" min="1" :data-testid="testIdPrefix + '-medicament-amount'">
          </div>
          <div class="col-sm-4 mb-2">
            <label for="dosage">Dávkování</label>
            <input v-model="medicament.dosage" type="text" class="form-control" aria-describedby="operationHelp"
                   id="dosage" :data-testid="testIdPrefix + '-medicament-dosage'">
            <small id="dosageError" class="form-text font-weight-bold"
                   v-if="medicamentError.dosage">{{ medicamentError.dosage.message }}</small>
          </div>
          <div class="col-sm-4 mb-2">
            <label for="repeating">Opakování</label>
            <input v-model="medicament.repeating" @change="repeatingChanged" type="number" class="form-control"
                   aria-describedby="operationHelp" id="repeating" min="2" step="1"
                   :disabled="medicament.electronic_prescription !== true">
          </div>
        </div>
        <div class="form-row align-items-end">
          <div class="col-sm-3 mb-2">
            <label for="acute">Akutní</label>
            <div>
              <label class="switch switch-lg switch-text switch-success">
                <input v-model="medicament.acute" @change="acuteChanged" type="checkbox" class="switch-input" id="acute"
                       checked>
                <span class="switch-label" data-on="Ano" data-off="Ne"></span>
                <span class="switch-handle"></span>
              </label>
            </div>
          </div>
          <div class="col-sm-3 mb-2">
            <label for="family">Rodina</label>
            <div>
              <label class="switch switch-lg switch-text switch-success">
                <input v-model="medicament.family" type="checkbox" class="switch-input" id="family" checked>
                <span class="switch-label" data-on="Ano" data-off="Ne"></span>
                <span class="switch-handle"></span>
              </label>
            </div>
          </div>
          <div class="col-sm-3 mb-2">
            <label for="separate">Samostatně</label>
            <div>
              <label class="switch switch-lg switch-text switch-secondary disabled">
                <input v-model="medicament.separate" type="checkbox" class="switch-input" id="separate" checked
                       disabled>
                <span class="switch-label" data-on="Ano" data-off="Ne"></span>
                <span class="switch-handle"></span>
              </label>
            </div>
          </div>
          <div class="col-sm-3 mb-2">
            <label for="validityInDays">Platnost (dní)</label>
            <input v-model="medicament.validity_in_days" type="number" class="form-control"
                   aria-describedby="operationHelp" id="validityInDays" min="1" max="365">
            <small class="form-text font-weight-bold">do {{ validToDate }}</small>
          </div>
        </div>
        <div class="form-row align-items-end">
          <div class="col-sm-3 mb-2">
            <label for="acute">E-RECEPT</label>
            <div>
              <label class="switch switch-lg switch-text switch-success">
                <input v-model="medicament.electronic_prescription" type="checkbox" class="switch-input" id="type"
                       checked :data-testid="testIdPrefix + '-medicament-electronic'">
                <span class="switch-label" data-on="Ano" data-off="Ne"></span>
                <span class="switch-handle"></span>
              </label>
            </div>
          </div>
          <div class="col-sm-3 mb-2">
            <label for="notification">Notifikace</label>
            <select v-model="medicament.patient_notification_type" class="form-control" aria-describedby="notification"
                    id="notification" :disabled="medicament.electronic_prescription !== true" :data-testid="testIdPrefix + '-medicament-notification'">
              <option v-for="(pn, index) in clientMedicineInfo.possible_notifications" :value="pn.key">{{
                  pn.label
                }}
              </option>
            </select>
          </div>
          <div class="col-sm-6 mb-2">
            <label for="note">Poznámka</label>
            <input v-model="medicament.note" type="text" class="form-control" aria-describedby="operationHelp"
                   id="note" :data-testid="testIdPrefix + '-medicament-note'">
          </div>
        </div>

        <div class="form-row">
          <div class="col-sm-12">
            <button type="submit" class="btn btn-success btn-sm" :data-testid="testIdPrefix + '-medicament-add'">Přidat lék</button>
          </div>
        </div>
      </form>
    </div>
  </div>
  </div>
</template>

<script>
import apiMixin from '@/mixins'
import _ from 'lodash'

export default {
  data () {
    return {
      medicineType: 'hvlp',
      selected: null,
      selectedDisease: null,
      // medicine: '',
      fromSearch: '',
      medicament: {
        medicine: '',
        individual_medicine: '',
        disease: null,
        amount: 1,
        dosage: '',
        paid_by_sick: false,
        validity_in_days: 14,
        repeating: null,
        electronic_prescription: true,
        patient_notification_type: false,
        separate: true
      },
      originalMedicamentValidityInDays: 14,
      // Medicament (post)
      medicamentPending: false,
      medicamentError: false,
      medicamentDone: false,
      // Medicines
      medicines: [],
      medicinesError: false,
      medicinesPending: false,
      // Medicines
      individualMedicines: [],
      individualMedicinesError: false,
      individualMedicinesPending: false,
      // Diseases
      diseases: [],
      diseasesPending: false,
      diseasesError: false,
      // client medicine info
      clientMedicineInfo: false,
      clientMedicineInfoPending: false,
      clientMedicineInfoError: false,
      clientMedicineInfoDone: false,
      readyToDuplicate: false
    }
  },
  mixins: [apiMixin],
  props: ['copiedMedicament', 'clientId', 'visitId'],
  methods: {
    getResult: _.debounce(function (text) {
      if (text.length > 2) {
        this.getMedicines(text)
      }
    }, 600),
    switchMedicineType (newType) {
      if (newType === 'hvlp') {
        this.medicineType = 'hvlp'
        this.medicament.individual_medicine = null
      } else {
        this.medicineType = 'iplp'
        this.medicament.medicine = null
      }
    },
    duplicateMedicineByCode (code) {
      this.readyToDuplicate = true
      this.getMedicines(code)
    },
    saveMedicament () {
      for (let property in this.medicament) {
        if (this.medicament.hasOwnProperty(property) && this.medicament[property] === '') {
          this.medicament[property] = null
        }
      }
      this.medicamentError = false
      this.postMedicament(this.medicament, this.clientId, this.visitId)
    },
    selectMedicine (val) {
      this.medicament.medicine = {'code': val.code}
      this.getClientMedicineInfo(this.clientId, val.code)
    },
    selectIndividualMedicine (val) {
      this.medicament.individual_medicine = {'id': val.id}
      this.getClientIndividualMedicineInfo(this.clientId, val.id)
    },
    medicamentAdded () {
      this.$emit('update')
    },
    selectDisease (val) {
      this.medicament.disease = {'code': val.code}
    },
    repeatingChanged (event) {
      if (event.target.valueAsNumber > 1) {
        this.medicament.validity_in_days = 182
      } else {
        this.medicament.validity_in_days = this.originalMedicamentValidityInDays
      }
    },
    acuteChanged () {
      if (this.medicament.acute === true) {
        this.medicament.validity_in_days = 1
      } else {
        this.medicament.validity_in_days = this.originalMedicamentValidityInDays
      }
    }
  },
  computed: {
    testIdPrefix () {
      return this.visitId ? 'visit' : 'client'
    },
    validToDate () {
      return this.$moment().add(this.medicament.validity_in_days, 'days').format('L')
    }
  },
  watch: {
    medicinesPending (val) {
      if (val === false && this.readyToDuplicate === true) {
        this.selected = this.medicines[0]
        this.selectMedicine({code: this.medicines[0].code})
      }
    },
    medicamentDone (val) {
      if (val === true) {
        this.medicament = {
          medicine: '',
          disease: null,
          amount: 1,
          dosage: '',
          paid_by_sick: false,
          validity_in_days: 14,
          repeating: null,
          electronic_prescription: true,
          patient_notification_type: null,
          separate: true
        }
        this.clientMedicineInfo = false
        this.selected = null
        this.$emit('update')
        this.medicamentDone = false
      }
    },
    clientMedicineInfoDone (val) {
      if (val === true && this.readyToDuplicate === true) {
        this.medicament.disease = this.copiedMedicament.disease
        this.medicament.amount = this.copiedMedicament.amount
        this.medicament.dosage = this.copiedMedicament.dosage
        this.medicament.family = this.copiedMedicament.family
        this.medicament.paid_by_sick = this.copiedMedicament.paid_by_sick
        this.medicament.repeating = this.copiedMedicament.repeating

        if (this.copiedMedicament.prescription && this.copiedMedicament.prescription.patient_notification_type) {
          this.medicament.patient_notification_type = this.copiedMedicament.prescription.patient_notification_type
        } else {
          this.medicament.patient_notification_type = this.clientMedicineInfo.possible_notifications[this.clientMedicineInfo.possible_notifications.length - 1].key
        }
        this.medicament.validity_in_days = this.clientMedicineInfo.validity
        this.originalMedicamentValidityInDays = this.clientMedicineInfo.validity

        this.readyToDuplicate = false
      } else if (val === true) {
        if (this.clientMedicineInfo.disease) {
          this.selectedDisease = this.clientMedicineInfo.disease
          this.selectDisease(this.clientMedicineInfo.disease)
        } else {
          this.selectedDisease = null
          this.medicament.disease = null
        }

        if (this.clientMedicineInfo.dosage) {
          this.medicament.dosage = this.clientMedicineInfo.dosage
        } else {
          this.medicament.dosage = ''
        }
        this.medicament.patient_notification_type = this.clientMedicineInfo.possible_notifications[this.clientMedicineInfo.possible_notifications.length - 1].key
        this.medicament.paid_by_sick = this.clientMedicineInfo.paid_by_sick
        this.medicament.validity_in_days = this.clientMedicineInfo.validity
        this.originalMedicamentValidityInDays = this.clientMedicineInfo.validity
      }
    },
    copiedMedicament (val) {
      if (val !== null) {
        this.duplicateMedicineByCode(val.medicine.code)
      }
    }
  }
}
</script>

<style>
span.multiselect__option {
  min-height: 10px !important;
  padding: 3px !important;
}

div.multiselect__content-wrapper {
  z-index: 1050 !important;
}

span.option__title.available {
  color: #000;
  font-weight: bolder;
}

span.option__title.unavailable {
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/views/Prescribtion/AddMedicament.vue?53dcb965